(function () {
  const Online = window.RB.Online;

  const S = {
    list: [], listErr: null, listed: false, poll: null,
    id: null, lobby: null, seat: -1, down: false, err: null, busy: false,
    agent: null, info: null,
  };
  let onChange = null;

  function emit() { if (onChange) onChange(); }

  function refreshList() {
    return Online.api("GET", "/api/lobbies").then(function (list) {
      const sig = JSON.stringify(list);
      const changed = sig !== S.listSig || !S.listed || S.listErr;
      S.list = list;
      S.listSig = sig;
      S.listed = true;
      S.listErr = null;
      if (changed) emit();
    }).catch(function (e) {
      S.listErr = "Server unreachable: " + e.message;
      emit();
    });
  }

  function watchList(on) {
    if (on && !S.poll) {
      refreshList();
      S.poll = setInterval(refreshList, 2000);
    } else if (!on && S.poll) {
      clearInterval(S.poll);
      S.poll = null;
    }
  }

  function fetchInfo() {
    if (S.info) return;
    fetch("/api/ping").then(function (r) { return r.json(); }).then(function (j) {
      S.info = { agentSeats: j.agentSeats === true };
      emit();
    }).catch(function () {
      S.info = { agentSeats: false };
      emit();
    });
  }

  function wire() {
    Online.Net.onReady = function () {
      S.down = false;
      if (S.id) Online.send({ t: "joinLobby", lobbyId: S.id });
    };
    Online.Net.onDown = function () { S.down = true; emit(); };
    Online.Net.onMessage = function (msg) {
      if (msg.t === "lobby") {
        S.lobby = msg.lobby;
        S.seat = msg.you === undefined ? -1 : msg.you;
        S.err = null;
        emit();
        return;
      }
      if (msg.t === "start") { Online.go("/game/" + msg.gameId); return; }
      if (msg.t === "error") { S.err = msg.msg; S.busy = false; emit(); }
    };
  }

  function enter(id) {
    S.id = id;
    S.lobby = null;
    S.seat = -1;
    S.agent = null;
    S.err = null;
    watchList(false);
    wire();
    if (!Online.playerName()) Online.setPlayerName("Player");
    if (Online.Net.live) Online.send({ t: "joinLobby", lobbyId: id });
    else Online.connect();
    history.replaceState(null, "", "/online/lobby/" + id);
    emit();
  }

  function create(name, best) {
    if (S.busy) return Promise.resolve(null);
    S.busy = true;
    S.err = null;
    emit();
    return Online.api("POST", "/api/lobbies", {
      playerId: Online.playerId(), name: Online.playerName(), lobbyName: name || "", best: best || 1,
    })
      .then(function (lobby) {
        S.busy = false;
        enter(lobby.id);
        return lobby;
      })
      .catch(function (e) {
        S.busy = false;
        S.err = e.message;
        emit();
        return null;
      });
  }

  function seatClaude(deck, best) {
    return create("", best).then(function (lobby) {
      if (!lobby) return null;
      S.busy = true;
      emit();
      return fetch("/api/agent/seats", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ lobbyId: lobby.id, name: "Claude", deck: deck || null, deckId: deck ? deck.id : null }),
      }).then(function (r) { return r.json(); }).then(function (j) {
        S.busy = false;
        if (j.error) S.err = j.error;
        else S.agent = j;
        emit();
        return S.agent;
      }).catch(function (e) {
        S.busy = false;
        S.err = "Could not seat Claude: " + e.message;
        emit();
        return null;
      });
    });
  }

  function leave() {
    if (S.id) Online.send({ t: "leaveLobby" });
    S.id = null;
    S.lobby = null;
    S.seat = -1;
    S.agent = null;
    S.err = null;
    S.busy = false;
    if (location.pathname.indexOf("/online/lobby/") === 0) history.replaceState(null, "", "/play");
    emit();
  }

  function mySeat() { return S.seat; }

  function iAmReady() {
    return S.seat >= 0 && S.lobby && S.lobby.seats[S.seat] ? !!S.lobby.seats[S.seat].ready : false;
  }

  function other() {
    if (S.seat < 0 || !S.lobby) return null;
    return S.lobby.seats[S.seat === 0 ? 1 : 0] || null;
  }

  function otherReady() {
    const o = other();
    return !!(o && o.ready);
  }

  function setReady(ready, deck) {
    if (ready && !deck) { S.err = "Pick a deck first."; return emit(); }
    S.err = null;
    Online.send({ t: "ready", ready: ready, deck: ready ? deck : null });
  }

  Online.Lobby = {
    S: S,
    onChange: function (fn) { onChange = fn; },
    watchList: watchList,
    refreshList: refreshList,
    fetchInfo: fetchInfo,
    enter: enter,
    create: create,
    seatClaude: seatClaude,
    leave: leave,
    mySeat: mySeat,
    iAmReady: iAmReady,
    other: other,
    otherReady: otherReady,
    setReady: setReady,
    inLobby: function () { return !!S.id; },
  };
})();
